module.exports = __webpack_public_path__ + "assets/b96.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b96.png
// module id = 689
// module chunks = 0